/**
 * Función que muestra el contenido correcto según el tipo de cliente
 * @param {string} customerType - Tipo de cliente ('private' o 'business')
 */
function showCustomerTypeContent(customerType) {
  const privateState = customerType == 'private' ? 'inherit' : 'none';
  const businessState = customerType == 'business' ? 'inherit' : 'none';

  document.querySelectorAll('[data-visible="private"]').forEach((item) => {
    item.style.display = privateState;
  });

  document.querySelectorAll('[data-visible="business"]').forEach((item) => {
    item.style.display = businessState;
  });

  handleEvent(customerType);
}

function handleEvent(customerType) {
    const messageEvent = new CustomEvent("custom-type:change", {
      detail: { customerType },
      bubbles: true,
      composed: true
    });
    document.dispatchEvent(messageEvent);
}

window.showCustomerTypeContent = showCustomerTypeContent;